import React, { useEffect, useState } from 'react';
import Dashboard from '../../../components/shared/dashboard/dashboard';
import MakeReservation from '../../../components/shared/make-reservation/make-reservation';
import { MakeReservationVariant } from '../../../components/shared/make-reservation/make-reservation.constants';
import { useDispatch, useSelector } from 'react-redux';
import LinearLoading from '../../../components/base/loading/linear-loading/linear-loading';
import { AdminNewReservationPageStyled } from './admin-new-reservation.page.styled';
import Form from '../../../components/shared/form/form';
import CustomerDataForm from './components/customer-data-form/customer-data-form';
import { ValidationCustomerDataSchema } from './components/customer-data-form/customer-data-form.constants';
import i18n from '../../../translations/strings';
import { makeReservationResetState } from '../../../store/shared/make-reservation.store';
import { handleReservationResetState } from '../../../store/admin/handle-reservation.store';

const AdminNewReservationPage = () => {
  const dispatch = useDispatch();

  const { loading, bookingSent, error } = useSelector((state: any) => {
    return state.makeReservation;
  });

  const [customerDataForm, setCustomerDataForm] = useState(null);
  const [showMakeReservation, setShowMakeReservation] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const onSubmit = (data: any) => {
    setCustomerDataForm(data);
    setShowMakeReservation(true);
  };

  useEffect(() => {
    dispatch(makeReservationResetState());
    dispatch(handleReservationResetState());
  }, []);

  useEffect(() => {
    if (bookingSent) {
      setShowMakeReservation(false);
      setCustomerDataForm(null);
      setResetForm(true);
    }
  }, [bookingSent]);

  useEffect(() => {
    if (error) {
      setShowMakeReservation(false);
    }
  }, [error]);

  return (
    <Dashboard callingPage={'AdminNewReservationPage'}>
      <AdminNewReservationPageStyled.Container>
        <LinearLoading loading={loading} />
        <AdminNewReservationPageStyled.ContainerForm>
          <AdminNewReservationPageStyled.ContainerTitle>
            <AdminNewReservationPageStyled.TitlePage>
              {i18n.t('adminNewReservation.dataCustomerTitle')}
            </AdminNewReservationPageStyled.TitlePage>
          </AdminNewReservationPageStyled.ContainerTitle>
          <Form schema={ValidationCustomerDataSchema}>
            <CustomerDataForm
              setResetForm={() => setResetForm(false)}
              resetForm={resetForm}
              onSubmit={onSubmit}
            />
          </Form>
        </AdminNewReservationPageStyled.ContainerForm>
        {showMakeReservation && customerDataForm && (
          <MakeReservation
            customerData={customerDataForm}
            variant={MakeReservationVariant.Customer}
          />
        )}
      </AdminNewReservationPageStyled.Container>
    </Dashboard>
  );
};

export default AdminNewReservationPage;
